const MILESTONES = [
  { amount: 100_000,         emoji: '🌱', title: 'First Milestone!' },
  { amount: 500_000,         emoji: '🌿', title: 'Half a Million' },
  { amount: 1_000_000,       emoji: '🎉', title: 'Millionaire!' },
  { amount: 5_000_000,       emoji: '💎', title: 'Five Million' },
  { amount: 10_000_000,      emoji: '🚀', title: 'Ten Million' },
  { amount: 25_000_000,      emoji: '🏆', title: 'Twenty-Five Million' },
  { amount: 50_000_000,      emoji: '👑', title: 'Fifty Million' },
  { amount: 75_000_000,      emoji: '💫', title: 'Seventy-Five Million' },
  { amount: 100_000_000,     emoji: '🦁', title: 'One Hundred Million' },
  { amount: 500_000_000,     emoji: '🌟', title: 'Five Hundred Million' },
  { amount: 1_000_000_000,   emoji: '🎊', title: 'Billionaire!' },
];

export default MILESTONES;
